<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/')"></span>
    </div>
    <div class="title">请选择清洁类型</div>
    <br>
    <div class="main">
      <div class="btn-long btn1  no-margin-top" @click="goto('/clean-step1')">
        <div>退房清洁<br><span class="btn-intro">高质量退房清洁服务，保证Agent满意</span></div>
      </div>
      <div class="btn-long btn2 " @click="goto('/service/form/clean?service=dasaochu')">
        <div>大扫除清洁<br><span class="btn-intro">整屋或单间的深度清洁服务</span></div>
      </div>
      <div class="btn-long btn3 " @click="goto('/service/form/clean?service=duanzuwu')">
        <div>短租房清洁<br><span class="btn-intro">专业 Airbnb 房屋清洁，安心接待住客</span></div>
      </div>
      <div class="btn-long btn4 " @click="goto('/service/form/clean?service=zhuanxiang')">
        <div>专项清洁<br><span class="btn-intro">地毯、油烟机、门窗墙面等专项清洁</span></div>
      </div>
      <div class="btn-long btn5 " @click="goto('/service/form/clean?service=zhouqi')">
        <div>周期清洁<br><span class="btn-intro">预约定期上门清洁服务</span></div>
      </div>
    </div>
    <img :src="pixelURL('clean','XuanZeLeiXing')" class="hide">

  </div>
</template>

<script>
export default {
  name: 'clean-switch',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  width: 85%;
  height: 90px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 1.2em;
  margin: 0 auto;
  margin-top: 20px;
  padding-left:6vw;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.btn1_grey{
  background: rgb(255,190,68);
  background:url('../../assets/img/other/household.svg') center right no-repeat,linear-gradient(90deg, #bbb 0%,#eee 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(0,0,0,0.2);
  -moz-box-shadow: 0 10px 16px -10px rgba(0,0,0,0.2);
  box-shadow: 0 10px 16px -10px rgba(0,0,0,0.2);
}

.btn1{
  background: rgb(255,190,68);
  background:url('../../assets/img/clean/switch/elo.svg') right bottom no-repeat,linear-gradient(90deg, #FFBE44 0%,#FBDD88 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
}

.btn2{
  background: rgb(255,128,154);
  background:url('../../assets/img/clean/switch/normal.svg') right bottom no-repeat,linear-gradient(90deg, #FF809A 0%,#FFAC7F 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
}

.btn3{
  background: rgb(105,205,243);
  background:url('../../assets/img/clean/switch/shorttime.svg') right bottom no-repeat,linear-gradient(90deg, #69CDF3 0%,#87F5E3 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
}

.btn4{
  background: rgb(105,205,243);
  background:url('../../assets/img/clean/switch/specific.svg') right bottom no-repeat,linear-gradient(90deg, #9BB6FF 0%,#ABE0F9 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
}

.btn5{
  background: rgb(105,205,243);
  background:url('../../assets/img/clean/switch/multime.svg') right bottom no-repeat,linear-gradient(90deg, #F78A3A 0%,#FFC974 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255, 201, 116, 0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255, 201, 116, 0.8);
  box-shadow: 0 10px 16px -10px rgba(255, 201, 116, 0.8);
}



.no-margin-top{
  margin-top:0;
}

</style>



// WEBPACK FOOTER //
// src/pages/clean/clean-switch.vue